import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import OverlayModal from './OverlayModal'
import { subscribeSlowHint } from '../../utils/startupSlowHint'

/**
 * 慢启动提示弹窗（全局单例，App.tsx 挂载一次）
 *
 * 触发：startupSlowHint 检测到启动耗时 > 8s（仅增量同步路径 + 云端对齐 + 24h 去重；
 * 全量下载（新装/换设备/手动全量重下）耗时长属预期，不触发）。
 * 未触发时渲染 null，零渲染成本。
 *
 * 框架：OverlayModal（项目统一弹窗规范：标题栏+关闭+卡片+Esc+滚动锁定+
 * 暗色适配）+ Portal 到 document.body（项目弹窗定位约定，逃离祖先层叠上下文）。
 * align="top" 中上定位：提示弹出时启动聚焦的键盘已打开，移动端默认的底部对齐
 * 会被键盘遮挡卡片与确认按钮；确认按钮为全宽大圆角（移动端风格）。
 */
const StartupSlowHintDialog: React.FC = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => subscribeSlowHint(() => setVisible(true)), [])

  if (!visible) return null

  return createPortal(
    <OverlayModal
      open
      title="启动较慢提示"
      onClose={() => setVisible(false)}
      maxWidth={420}
      align="top"
    >
      <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed mb-6">
        检测到刚才的启动速度过慢，这可能是由于初始化过程未完成造成的，不影响数据完整，请保持应用 60-90 秒不关闭，下次启动即可恢复 3 秒左右启动。
      </p>
      <button
        type="button"
        onClick={() => setVisible(false)}
        className="w-full py-3 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 rounded-xl transition-colors"
      >
        知道了
      </button>
    </OverlayModal>,
    document.body
  )
}

export default StartupSlowHintDialog
